import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntities as getCompanies } from 'app/entities/company/company.reducer';
import { getEntities as getTruckImplements } from 'app/entities/truck-implement/truck-implement.reducer';
import { createEntity, getEntity, reset, updateEntity } from './representative-truck-implement.reducer';

export const RepresentativeTruckImplementUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const companies = useAppSelector(state => state.company.entities);
  const truckImplements = useAppSelector(state => state.truckImplement.entities);
  const representativeTruckImplementEntity = useAppSelector(state => state.representativeTruckImplement.entity);
  const loading = useAppSelector(state => state.representativeTruckImplement.loading);
  const updating = useAppSelector(state => state.representativeTruckImplement.updating);
  const updateSuccess = useAppSelector(state => state.representativeTruckImplement.updateSuccess);

  const handleClose = () => {
    props.history.push('/representative-truck-implement' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getCompanies({}));
    dispatch(getTruckImplements({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...representativeTruckImplementEntity,
      ...values,
      company: companies.find(it => it.id.toString() === values.companyId.toString()),
      truckImplement: truckImplements.find(it => it.id.toString() === values.truckImplementId.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...representativeTruckImplementEntity,
          companyId: representativeTruckImplementEntity?.company?.id,
          truckImplementId: representativeTruckImplementEntity?.truckImplement?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.representativeTruckImplement.home.createOrEditLabel" data-cy="RepresentativeTruckImplementCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.representativeTruckImplement.home.createOrEditLabel">Create or edit a RepresentativeTruckImplement</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="representative-truck-implement-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                id="representative-truck-implement-company"
                name="companyId"
                data-cy="company"
                label={translate('fleetSenseApp.representativeTruckImplement.company')}
                type="select"
              >
                <option value="" key="0" />
                {companies
                  ? companies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="representative-truck-implement-truckImplement"
                name="truckImplementId"
                data-cy="truckImplement"
                label={translate('fleetSenseApp.representativeTruckImplement.truckImplement')}
                type="select"
              >
                <option value="" key="0" />
                {truckImplements
                  ? truckImplements.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/representative-truck-implement" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default RepresentativeTruckImplementUpdate;
